// @mui material components
import Card from "@mui/material/Card";
// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
// Soft UI Dashboard PRO React example components
import DashboardNavbar from "cxfcomponents/Navbars/DashboardNavbar";
import DashboardLayout from "cxfcomponents/LayoutContainers/DashboardLayout";
import { FlowsTable } from "./components/Table";

function Flows() {
  return (
    <>
      <div style={{
        padding: "8px",
        position: "sticky",
        top: 0,
        zIndex: 1000,
        backgroundColor: "var(--main-bg-color)"
      }}>
        <DashboardNavbar />
      </div>
      <DashboardLayout sx={{ pt: 0, pb: 0 }}>
        <SoftBox sx={{ mt: -4.2, mb: 0.5 }}>
          <Card sx={{
            p: "8px 0 0 0",
            mb: -0.4,
            background: "none !important",
            boxShadow: "none"
          }}
          >
            <FlowsTable tableHeight="clamp(400px, calc(100vh - 83px), calc(100vh - 83px))" />
          </Card>
        </SoftBox>
      </DashboardLayout>
    </>
  );
}

export default Flows;
